// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M3.516.032a.836.836 0 0 0-.448.4L3.012.54l-.007 3.576c-.005 2.526 0 3.643.02 3.804a3.76 3.76 0 0 0 2.759 3.202l.204.055L6 17.318l.012 6.142.056.108c.186.358.584.52.945.385a.81.81 0 0 0 .423-.404l.064-.137.012-6.12.012-6.12.192-.051a3.761 3.761 0 0 0 2.66-2.676c.126-.475.124-.39.124-4.257v-3.6l-.064-.137A.753.753 0 0 0 9.069.428L9.012.54 9 4.176l-.013 3.636-.063.228c-.034.125-.09.29-.124.365a2.42 2.42 0 0 1-.692.874 2.69 2.69 0 0 1-.542.308l-.053.016-.007-4.508L7.5.588 7.436.451A.753.753 0 0 0 6.069.428L6.012.54l-.006 4.53C6 8.32 5.992 9.6 5.973 9.6c-.014 0-.114-.043-.222-.096a2.308 2.308 0 0 1-1.097-1.21c-.137-.37-.127-.074-.141-4.046L4.5.588 4.436.451a.81.81 0 0 0-.418-.402c-.147-.055-.385-.063-.502-.017m12.621.015c-.44.116-.788.4-.991.81-.157.317-.145-.65-.146 11.493 0 10.076.003 11.051.039 11.155.049.144.233.346.384.423a.785.785 0 0 0 .59.025.81.81 0 0 0 .423-.404l.064-.137.007-3.45.006-3.45h1.158c1.406 0 1.619-.02 1.997-.185.747-.328 1.271-1.056 1.324-1.843.026-.4-.09-2.805-.197-4.044-.24-2.812-.754-5.043-1.637-7.116C18.705 2.26 17.93.839 17.611.491a1.51 1.51 0 0 0-1.474-.444m.375 8.218v6.737l1.23-.007c1.196-.007 1.233-.008 1.34-.058a.753.753 0 0 0 .353-.365l.06-.132-.016-.53c-.049-1.635-.152-3.183-.293-4.382-.351-2.99-1.146-5.468-2.453-7.644-.111-.185-.206-.34-.212-.346-.005-.006-.009 3.022-.009 6.727"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const TavernIcon = Icon;
export default TavernIcon;
